// Unknown or missing values are false; objects are never coerced to strings.
export function toBoolean(value) {
  if (typeof value === 'string') {
    return ['1', 'true', 't', 'yes', 'y', 'on'].includes(value.trim().toLowerCase());
  }

  return value === true || value === 1;
}
